import React, { Fragment, useCallback, useState } from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Panel from '../../../../../components/outline/Panel';
import ImgUpload from '../../../../../components/ImgUpload';
import TextArea from '../../../../../components/input/TextArea';
import Input from '../../../../../components/input/Input';
import Button from '../../../../../components/Button';
import Drawer from '../../../../../components/Drawer/Drawer';
import Img from '../../../../../components/Img/Img';
import RadioGroup from '../../../../../components/input/RadioGroup';
import {
  MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO,
  MAXIMUM_NUMBER_OF_REMOTE_IMAGE,
  MINIMUM_NUMBER_OF_REMOTE_IMAGE,
  REMOTE_SPLASH_IMAGE_WIDTH,
  REMOTE_SPLASH_IMAGE_HEIGHT,
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/remoteImageConstants';
import remoteSplashInfo from '../../../../../static/images/remote/splash/remote-splash-info.png';
import { IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';
import './RemoteImageSplashDetailInfo.scss';

const RemoteImageSplashDetailInfo = (props) => {
  const { remoteImageSplashDetail, setData, copyUrl } = props;
  const { remoteImg, memo, imgUrl, status } = remoteImageSplashDetail;

  /**
   *  미리보기
   */
  const [drawerVisible, setDrawerVisible] = useState(false);
  const toggleDrawerVisible = useCallback(() => setDrawerVisible(!drawerVisible), [drawerVisible]);

  return (
    <Panel className="remote-image-detail-info">
      <div className="panel-header">
        <div className="title">스플래시 이미지 정보</div>
        <Button isRadius color="primary" text="미리보기" onClick={() => toggleDrawerVisible()} />
      </div>

      <div className="panel-body">
        <BaseForm
          label="스플래시 상태"
          content={
            <RadioGroup
              value={status}
              list={REMOTE_IMAGE_ACTIVE_STATUS_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['remoteImageSplashDetail', 'status'],
                  value,
                })
              }
              size="large"
            />
          }
          subContent={<span className="sub-info">스플래시 이미지는 등록된 이미지 중 1개만 활성화 할 수 있습니다.</span>}
        />

        <BaseForm
          label="이미지"
          content={
            <ImgUpload
              list={remoteImg}
              modalTitle="스플래시 이미지"
              maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE}
              minCnt={MINIMUM_NUMBER_OF_REMOTE_IMAGE}
              setData={setData}
              targetPath={['remoteImageSplashDetail', 'remoteImg']}
              restriction={{
                width: REMOTE_SPLASH_IMAGE_WIDTH,
                height: REMOTE_SPLASH_IMAGE_HEIGHT,
              }}
            />
          }
          subContent={
            <div className="sub-info">
              <div>
                *이미지 사이즈 : {REMOTE_SPLASH_IMAGE_WIDTH} x {REMOTE_SPLASH_IMAGE_HEIGHT} px 만 등록 가능합니다.
              </div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
              <div>*파일 크기는 가능한 최소 용량을 권장 드립니다.</div>
            </div>
          }
        />

        {imgUrl && (
          <BaseForm
            label="이미지 URL"
            content={
              <Fragment>
                <Input className="img-url-input" value={imgUrl} disabled={true} />

                <Button className="img-url-copy" text="복사하기" onClick={() => copyUrl(imgUrl)} />
              </Fragment>
            }
          />
        )}

        <BaseForm
          label={
            <div className="remote-image-detail-memo-label">
              <div>메모</div>
              <div>
                (<span className="word-length">{memo && memo.length ? memo.length : 0}</span>/
                {MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO})
              </div>
            </div>
          }
          content={
            <TextArea
              value={memo}
              maxLength={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO}
              onChange={(value) =>
                setData({
                  path: ['remoteImageSplashDetail', 'memo'],
                  value,
                })
              }
            />
          }
        />
      </div>

      <Drawer
        className="remote-image-info-drawer"
        title="스플래시 이미지"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
      >
        <Img clickAble={false} src={remoteSplashInfo} />
      </Drawer>
    </Panel>
  );
};

export default RemoteImageSplashDetailInfo;
